<template>
<md-dialog :md-active.sync="active" :md-close-on-esc="false"
:md-click-outside-to-close="false" >
  <md-dialog-title>{{ i18n.lbl_delegate_btn() }}</md-dialog-title>
  <div class="inputs">
    <SelectField :label="i18n.lbl_approvers()" v-model="user" :values="formatApprovers"/>
    <DateFieldFlatpickr class="date-picker" v-model="from" :minDate="new Date(new Date().setHours(0, 0, 0, 0))" :label="i18n.lbl_start_date()" title="Choose before this date" clearable/> 
    <DateFieldFlatpickr class="date-picker" :minDate="new Date(new Date().setHours(0, 0, 0, 0))" :label="i18n.lbl_end_date()" v-model="to" title="Choose before this date" clearable/>
  </div>
  <span class="red" v-if="error">{{ error }}</span>
  <md-dialog-actions>
    <md-button class="md-button btn md-primary md-theme-default" @click="close" :disabled="isLoading">{{ i18n.lbl_cancel() }}</md-button>
    <md-button class="md-button btn md-primary md-theme-default" @click="delegateHandler" :disabled="disabledDelegate">{{ i18n.lbl_delegate_btn() }}</md-button>
  </md-dialog-actions>
</md-dialog>
</template>

<script>
import { i18n } from '@js/i18n'
import SelectField from '@com/fields/SelectField'
import DateFieldFlatpickr from '../../common/fields/DateFieldFlatpickr.vue'
export default {
  name: 'DelegateModal',
  components: { SelectField, DateFieldFlatpickr },
  emits: ['close', 'delegate', 'clearErr'],
  props: {
    active: {
      type: Boolean,
      default: false
    },
    approvers: {
      default: []
    },
    error: {
      default: null
    }
  },
  data () {
    return {
      i18n,
      isLoading: false,
      user: '',
      to: '',
      from: ''
    }
  },
  methods: {
    async delegateHandler () {
      if (this.user && this.to && this.from) {
        this.isLoading = true
        await this.$emit('delegate', {email: this.user, to: this.to, from: this.from})
        this.isLoading = false
      }
    },
    close () {
      this.$emit('clearErr')
      this.$emit('close')
    }
  },
  computed: {
    formatApprovers () {
      if (this.approvers.length) {
        return this.approvers.map(el => el.approver_email)
      }
      return []
    },
    disabledDelegate () {
      return !(this.user && !this.isLoading && this.to && this.from)
    }
  }
}
</script>
<style scoped lang="scss">
@import '~scss/variables';
.date-picker {
   margin: 16px 0px;
}
.red {
  color: $error-red;
  font-size: 12px;
}
</style>


// WEBPACK FOOTER //
// src/vue/app/widrawalRequest/DelegateModal.vue